import {
  Column,
  Container,
  InputCell,
  Row,
  Subtitle,
  Timer,
  Title
} from "./Styles";
import { useTheme } from 'styled-components'

// components

import Buttons from 'components/Buttons'
import AuthHeader from "../Header";
import Input from "components/Input";

//icons

import LockIcon from "components/StaticIcons/Lock";
import MailIcon from "components/StaticIcons/Mail";
import PinIcon from "components/StaticIcons/Pin";
import RecoveryPinIcon from "components/StaticIcons/RecoveryPin";
import { useState } from "react";
import ShieldIcon from "components/StaticIcons/Shield";

export default function RecoveryPage() {

  const theme = useTheme()

  return (
    <>
      <AuthHeader />
      <Container>
        {/* <Column bottom="2.4rem">
          <LockIcon width="4rem" height="4rem" fill={theme.colors.pink100} />
          <Title>Recovery account</Title>
        </Column>
        <Row bottom="1.2rem">
          <Input placeholder='E-mail' leftElement={<MailIcon />} />
        </Row>
        <Buttons variable="solid" height="big">
          Next step
        </Buttons> */}
        {/* <Column bottom=".8rem">
          <RecoveryPinIcon />
          <Title>Enter the code</Title>
        </Column>
        <Row justifyContent="center">
          <Subtitle>
            We have sent a recovery code to your email address.
          </Subtitle>
        </Row>
        <Row bottom="1.2rem">
          <InputCell>1</InputCell>
          <InputCell>2</InputCell>
          <InputCell>3</InputCell>
          <InputCell className="active">4</InputCell>
          <InputCell>1</InputCell>
          <InputCell>1</InputCell>
        </Row>
        <Buttons variable="solid" height="big">
          Next step
        </Buttons>
        <Row justifyContent="center">
          <Timer>
            <span>Didn't receive a code?</span> <span className="white">0:20</span>
          </Timer>
        </Row> */}
        <Column bottom="2.4rem">
          <ShieldIcon />
        </Column>
        <Row bottom=".8rem">
          <Input placeholder="New password" leftElement={<LockIcon />} />
        </Row>
        <Buttons variable="solid" height="big">
          Finish recovery
        </Buttons>
      </Container>
    </>
  )
}
